import { ReactElement, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useModelStore } from '@editorStores'
import { useHiddenElements } from '@editorHooks'
import useAIChatFindingsStore, { type SceneFinding } from 'src/state/stores/aiChatFindings'
import FindingMarker from './FindingMarker'
import { markerGroups } from './utils'

const NO_FINDINGS: SceneFinding[] = []

/**
 * A "!" at every element the AI chat's check findings concern (`show_findings`), coloured by
 * the worst finding; a click opens the findings right at the element. Elements on the same spot
 * share one "!"; elements the scene hides get none, like their outlines, and none show while the
 * user hid the findings (the chat's chip).
 */
const AIChatFindingMarkers = (): ReactElement | null => {
  const { projectId } = useParams()
  const findings = useAIChatFindingsStore(state =>
    projectId ? state.findingsByProject[projectId] ?? NO_FINDINGS : NO_FINDINGS,
  )
  const hidden = useAIChatFindingsStore(state =>
    projectId ? state.hiddenByProject[projectId] ?? false : false,
  )
  const model = useModelStore(state => state.model)
  const hiddenElements = useHiddenElements()

  const groups = useMemo(
    () => (hidden ? [] : markerGroups(model, findings, hiddenElements)),
    [hidden, model, findings, hiddenElements],
  )

  if (!projectId || groups.length === 0) return null

  return (
    <>
      {groups.map(group => (
        <FindingMarker key={group.key} projectId={projectId} group={group} />
      ))}
    </>
  )
}

export default AIChatFindingMarkers
